import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    //console.log('Recibido en interpret:', data)
    const consult = `Quiero que interpretes una **Tirada de Protección y Energía**  para ${data.consultante}, ${
        data.consulta.length > 0 ? 'que realiza la siguiente consulta: ' + data.consulta + ',' : ''
    } según estas cartas: **Energía actual:** ${formatCardLabel(cards[0])}, **Energía externa influyendo:** ${formatCardLabel(cards[1])}, **Origen del bloqueo o ataque:** ${formatCardLabel(cards[2])}, **Punto vulnerable:** ${formatCardLabel(cards[3])}, **Cómo protegerse:** ${formatCardLabel(cards[4])}, **Aliado espiritual:** ${formatCardLabel(cards[5])}, **Resultado si sigue el consejo:** ${formatCardLabel(cards[6])}. Explica detalladamente cada carta y su significado dentro de la tirada. Luego, brinda consejos específicos para la protección energética basados en la interpretación. Si detectas alguna energía negativa, sugiere limpiezas, amuletos o rituales adecuados. Mantén un tono profesional y comprensible. Dirígete directamente al consultante.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
